import { render } from "./TheNews.vue?vue&type=template&id=8bce1206&ts=true"
import script from "./TheNews.vue?vue&type=script&lang=ts"
export * from "./TheNews.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__